## mixin is required by forms on the site

validEmail = (email)->
    re = /\S+@\S+\.\S+/
    re.test email

shake = (id, invalid = '', delay = 1500)->
    el = $(id)
    jQuery('html, body').animate
        scrollTop: el.offset().top - 150
        delay - 500, null,
        -> do $(id + ' input').focus
    setTimeout (-> el[0].classList.add 'animated', 'shake', invalid), delay
    setTimeout (-> el[0].classList.remove 'animated', 'shake'), 2500 + delay
    false

@formMixin =
    data:
        sent:     false
        sending:  false

        terms:          false
        dataProcessing: false

    computed:
        formInvalid: ->
            return v if v = @otherValidation # additional form validation
            for key, field of @form
                continue if not field.compulsory
                return key if key is 'user_email' and not validEmail field.value
                return key if field.compulsory and field.value is ''
            return 'agree-on-terms' if not @terms
            return 'agree-on-data-processing' if not @dataProcessing
            false

    methods:
        validate: ->
            key = @formInvalid
            return shake '#' + key, 'invalid' if key
            true

        send: ->
            return if not do @validate
            @sending = true
            jQuery.ajax
                method:  'post'
                url:     '/wp-admin/admin-ajax.php'
                data:    @form
                success: => @sent = true
                error:   (response)=>
                    @sending = false
                    if +response.status is 409
                        alert "The registration email address has been used already, please try a different one."
                    else alert "Could not submit the application due to an error\n\n'#{response.responseJSON.data}'\n\nPlease send a message to info@elia-association.org instead."

prices =
    small:  550 # members < 500k turnover
    medium: 650 # members  > 500k turnover
    assoc:  750 # assoc members
    vat:    .21 # belgian vat rate

@makeMemberForm = (data)->
    new Vue
        el:     '#app'
        mixins: [formMixin]
        data: data

        computed:
            isBelgian: -> 'BE' in [@form.main_address_country.value, @form.registration_address_country.value]

            membershipPrice: ->
                full   = not @form.membership_status_associate.value
                amount = if full then prices.medium else prices.assoc
                small  = ['less than €250,000', '€250,000 - €500,000']
                if full and @form.company_specs_turnover.value in small
                    amount = prices.small
                vat    =  if @isBelgian then amount * prices.vat else 0

                amount: amount
                vat:    vat.toFixed(2)
                total:  (amount + vat).toFixed(2)

            costMessage: ->
                mp = @membershipPrice
                if @isBelgian
                    return "Membership price for 12 months is €#{mp.amount} plus Belgian €#{mp.vat} VAT with €#{mp.total} total."
                "Membership price for 12 months is €#{mp.total}."

        methods:
            makeTheSame: ->
                f = @form;
                f.registration_address_address_1.value = f.main_address_address_1.value
                f.registration_address_country.value   = f.main_address_country.value
                f.registration_address_address_2.value = f.main_address_address_2.value
                f.registration_address_post_code.value = f.main_address_post_code.value


@makeSpeakerForm = (data)->
    data.maxWordCount       = 170
    data.allowedWordCount   = data.maxWordCount - 20
    data.areYouSelfEmployed = value: false # not a part of the form, used in GUI

    new Vue
        el:     '#app'
        mixins: [formMixin]
        data: data

        watch:
            "areYouSelfEmployed.value": (isSelfEmployed)->
                f = @form.details_company # self::company
                f.compulsory = not isSelfEmployed
                f.value = '' if isSelfEmployed
                f = @form.details_position # self::position
                f.label = if isSelfEmployed then 'Main Area of Work' else 'Company Position'
                f = @form.details_elia_member # self::elia_member
                f.value = false if isSelfEmployed

        computed:
            wordCount: ->
                m = @form.description.value.match(/[^\s]+/g) # self:::wp_descr
                if m then m.length else 0

            otherValidation: ->
                return 'description' if @wordCount > @maxWordCount # self:::wp_descr
                false


@makeUniversityForm = (data)-> new Vue
    el:     '#app'
    mixins: [formMixin]
    data: data
